import './SideBarMenu.scss'
import { Icon, Menu, notification, Spin, Table } from 'antd'
import SubMenu from 'antd/lib/menu/SubMenu'
import React, { useEffect, useState } from 'react'
import { getSearchesPromise } from '../../../AdminSearch/promises'
import { camelizerHelper } from '../../../../helpers'
import { withRouter } from '../../../../helpers/withRouter'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const SideBarMenu = ({
  currentUser,
  collapsed,
  handleQuery
}) => {
  const { t } = useTranslation()

  const [openKeys, setOpenKeys] = useState(['sub1'])
  const [historyData, setHistoryData] = useState(null)
  const [isHistoryLoading, setIsHistoryLoading] = useState(false)

  useEffect(() => {
    if (collapsed === null) setHistoryData(null)
    else if (collapsed && !historyData) {
      getHistoryData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed])

  const handleMenuOpenChange = (keys) => {
    setOpenKeys(keys)
  }

  const getHistoryData = async () => {
    setIsHistoryLoading(true)

    try {
      const userId = currentUser?.id
      if (!userId) {
        setHistoryData(null)
        return
      }

      const anio = new Date().getFullYear()
      const result = await getSearchesPromise(0, 20, { userId })

      const recordsList = result && result.records ? result.records : []
      let fecha = null
      const records = []

      recordsList.forEach(rec => {
        const y = new Date(rec.fecha).getFullYear()
        const m = moment(rec.fecha)
        let f
        if (anio === y) {
          f = m.format("dddd DD [de] MMMM")
        } else {
          f = m.format("dddd DD [de] MMMM [de] YYYY")
        }
        if (fecha !== f) {
          records.push({ date: f })
          fecha = f
        }
        records.push({ rut: rec.rut, name: rec.nombre })
      })

      setHistoryData(records)
    } catch (e) {
      setHistoryData(null)
      notification['error']({
        message: t('messages.aml.error'),
        description: t('messages.aml.historyFetchError')
      })
    } finally {
      setIsHistoryLoading(false)
    }
  }

  const columns = [
    {
      title: t('messages.aml.rut'),
      dataIndex: 'rut',
      render: (value, row, index) => {
        const obj = {
          children: value,
          props: {},
        }
        if (row.date) {
          obj.props.className = 'fecha'
          obj.props.colSpan = 2
          obj.children = row.date
        }
        return obj
      }
    },
    {
      title: t('messages.aml.name'),
      dataIndex: 'name',
      render: (value, row, index) => {
        const obj = {
          children: camelizerHelper(value),
          props: {},
        }
        if (row.date) {
          obj.props.className = 'fechaName'
        }
        return obj
      }
    },

  ]

  const handleSearch = (text) => {
    handleQuery(text)
  }

  return (
    <div className={"sidebar-search-history collapsed-" + collapsed} style={{ display: collapsed === null ? 'none' : 'block', right: collapsed ? 0 : -300 }}>
      <Menu
        defaultSelectedKeys={['1']}
        openKeys={openKeys}
        onOpenChange={handleMenuOpenChange}
        mode="inline"
      >
        <SubMenu
          key="sub1"
          title={
            <span>
              <Icon type="history" />
              <span>{t('messages.aml.recentQueries')}</span>
            </span>
          }
        >
          {isHistoryLoading ?
            <Spin />
            :
            <Table
              dataSource={historyData || []}
              columns={columns}
              pagination={(historyData?.length || 0) > 10}
              size="small"
              onRow={(record) => {
                if (!record.date) {
                  return {
                    onClick: () => {
                      handleSearch(record.rut ?? record.name)
                    }
                  }
                }
              }}
            />
          }
        </SubMenu>
      </Menu>
    </div>
  )
}

export default withRouter(SideBarMenu)
